import { useBaseInfo } from 'apis/hooks'
import { Column } from 'components/common/layout'
import React, { useMemo } from 'react'
import {
  DashboardScoutRequestDetail,
  DashboardScoutRequestOneQueryParams,
} from 'types/common'
import { getFlattenedData, getConditions } from 'utils/formatters'
import {
  ProfileDetailSection,
  ProfileDetailSectionTitle,
  ProfileDetailConditionWrapper,
  ProfileDetailSectionSubText,
} from 'components/scouts/profile-detail/styles'
import { ConditionTags } from 'components/scouts/search/condition-tags'

export const ProfileDetailConditionSection: React.FC<{
  data: DashboardScoutRequestDetail
  params?: DashboardScoutRequestOneQueryParams
}> = ({ data, params }) => {
  const { data: baseInfo } = useBaseInfo()
  const { requiredConditions, normalConditions } = useMemo(() => {
    const flattenedLocations = getFlattenedData(
      baseInfo?.locations.filter((item) => !item.isRemote) || [],
      data.locations || [],
    )
    const profile = { ...data, locations: flattenedLocations }
    return {
      requiredConditions: getConditions({ profile, isRequired: true }),
      normalConditions: getConditions({ profile, isRequired: false }),
    }
  }, [baseInfo?.locations, data])
  return (
    <ProfileDetailSection>
      <ProfileDetailSectionTitle>구직 조건</ProfileDetailSectionTitle>
      <Column style={{ gap: 8 }}>
        <ProfileDetailConditionWrapper>
          <ProfileDetailSectionSubText>필수</ProfileDetailSectionSubText>
          {requiredConditions.length > 0 ? (
            <ConditionTags
              data={requiredConditions}
              params={params}
              salary={data.salary}
              serviceAreas={data.serviceAreas}
              fundingRounds={data.fundingRounds}
            />
          ) : (
            <ProfileDetailSectionSubText>
              필수 조건이 없어요.
            </ProfileDetailSectionSubText>
          )}
        </ProfileDetailConditionWrapper>
        <ProfileDetailConditionWrapper>
          <ProfileDetailSectionSubText>선호</ProfileDetailSectionSubText>
          {normalConditions.length > 0 ? (
            <ConditionTags
              data={normalConditions}
              params={params}
              salary={data.salary}
              serviceAreas={data.serviceAreas}
              fundingRounds={data.fundingRounds}
            />
          ) : (
            <ProfileDetailSectionSubText>
              선호 조건이 없어요.
            </ProfileDetailSectionSubText>
          )}
        </ProfileDetailConditionWrapper>
      </Column>
    </ProfileDetailSection>
  )
}
